export default "__VITE_ASSET__DOVdeWDF__"